import PointOnMap from "@/components/maps/PointOnMap";
import PolygonOnMap from "@/components/maps/PolygonOnMap";

const ObjectsLayer = ({ objects = [], color = "#bbbbbb" }) => {
  return objects.map((object, index) => {
    const { type, value } = object;

    if (type === "point") {
      if (!value?.lat || !value?.lon) return null;

      return (
        <PointOnMap key={index} lon={value.lon} lat={value.lat} color={color} />
      );
    }

    if (type === "polygon" || type === "parent_polygon") {
      if (!value?.length) return null;

      return <PolygonOnMap key={index} value={value} color={color} />;
    }

    return null;
  });
};

export default ObjectsLayer;
